import Button from "client/components/Button";
import { ButtonModes } from "client/components/Button/Button.types";
import React from "react";
import { useHistory, useLocation } from "react-router-dom";

export default function AnswerQuestionsButton() {
  const location = useLocation();
  const history = useHistory();

  return (
    <Button
      ariaLabel="Respond to info request"
      mode={ButtonModes.primary}
      text="Answer Questions"
      style={{
        width: 166,
        fontSize: 16,
        fontWeight: 700,
        lineHeight: "24px",
        fontFamily: "Lato",
      }}
      onClick={() => {
        history.push(`${location.pathname}?answerQuestions=true`);
      }}
    />
  );
}
